<template>
  <div>
    <b-row>
      <b-col>
        <ol class="list-unstyled m-0">
          <li class="info-section d-flex mt-3">
            <div class="left-section">
              <img
                src="/img/authentification/public/school-img_2.png"
                height="62px"
                class="primary-svg-filter"
                alt=""
                loading="lazy"
              />
            </div>
            <p v-html="$sanitize($t('login.login_sign_in.general_info_modal.part1'))" />
          </li>

          <li class="info-section d-flex mt-3">
            <div class="left-section position-relative">
              <span class="additional-pin font-weight-bold"
                    aria-hidden="true"
                    tabindex="-1"
              >1x</span>
              <img
                src="/brandings/default/login/sdui-activation-code.png"
                height="70px"
                class="primary-svg-filter"
                alt=""
                loading="lazy"
              />
            </div>
            <p v-html="$sanitize($t('login.login_sign_in.general_info_modal.part2'))" />
          </li>

          <li class="info-section d-flex mt-3">
            <div class="left-section"
                 aria-hidden="true"
                 tabindex="-1"
            >
              <SInput
                :label-text="$t('login.login_sign_in.error_info_modal.email.placeholder')"
                hide-label
                type="text"
                size="md"
                disabled
                class="mb-2 mini-input"
                :placeholder="$t('login.login_sign_in.error_info_modal.email.placeholder')"
                aria-hidden="true"
                tabindex="-1"
              />
              <SInput
                label-text="password"
                hide-label
                type="text"
                size="md"
                disabled
                class="mb-3 mini-input pw-input"
                placeholder="*****"
                aria-hidden="true"
                tabindex="-1"
              />
            </div>
            <p v-html="$sanitize($t('login.login_sign_in.general_info_modal.part3'))" />
          </li>

          <li class="info-section d-flex mt-3">
            <div class="left-section" aria-hidden="true">
              <p class="extra-lg mb-0 font-weight-bold"
                 aria-hidden="true"
                 tabindex="-1"
              >{{ $t('login.login_sign_in.login') }}</p>
            </div>
            <p v-html="$sanitize($t('login.login_sign_in.general_info_modal.part4'))" />
          </li>
        </ol>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'LoginGeneralInfo',
  mixins: [brandingMixin],
}
</script>

<style scoped lang="scss">
.info-section {
  .left-section {
    min-width: 105px;
    display: block;
    position: relative;
    font-size: pxtorem(12);

    .extra-lg {
      font-size: pxtorem(27);
      margin-left: 0;
      max-width: initial;
    }
  }

  :deep(.pw-input .s-input__placeholder) {
    margin-top: 3px;
  }

  p {
    max-width: calc(100% - 105px);
    margin-left: 10px;
  }

  .additional-pin {
    font-size: pxtorem(23);
    position: absolute;
    right: 7px;
    top: 0;
  }

  :deep(.s-input__input) {
    width: 100px;
    height: calc(1.1em + 0.75rem + 2px);
    border-radius: 7px;
  }

  .mini-input :deep(.s-input__label) {
    display: none;
  }

  .mini-input :deep(.s-input__input:disabled) {
    color: var(--s-black);
    background-color: var(--s-secondary);
  }
}
</style>
